<template>
  <div class="race-page-wrapper-global">
    <div class="race-page" v-show="!selectedImg">
      <RaceFilterHeader
        :filters="filters.header_filters"
        @changeFiltersHandler="changeFiltersHandler"
        :selectedFilters="selectedFilters"
        :carNumbersLabel="filteredCountImages === totalCountImages ? `${filteredCountImages}` : `${filteredCountImages}/${totalCountImages}`"
        @clearFilters="clearFilters"
      />
      <div class="race-page-wrapper">
        <div class="filter-aside-wrapper" v-if="isShowFiltersAside">
          <div class="el-scrollable">
            <BaseScrollbar>
              <RaceFilterSidebar :filters="filters.left_filters" @changeFiltersHandler="changeFiltersHandler" :selectedFilters="selectedFilters"/>
            </BaseScrollbar>
          </div>
        </div>
        <ShowAsideButton class="show-aside-button" :class="{'is-open': isShowFiltersAside}" :isShow="isShowFiltersAside" mirrored @toggle="changeIsShowFiltersAside"/>
        <el-spinner v-if="isLoadingRaceImages && !images.length" color="red"/>
        <div class="race-page-main" v-else-if="images && images.length">
          <div class="el-scrollable" :class="{'is-compare-footer': isShowComparesFooter}">
            <RecycleRaceGallery
              ref="raceGallery"
              :imgList="images"
              :newImgList="newImgList"
              :currentPage="currentPage"
              :previousPage="previousPage"
              :selectedFilters="selectedFilters"
              @scrollystart="scrollystart"
              @scrollyend="scrollyend"
              @scroll="scroll"
              @selectImg="selectImg"
            />
          </div>
          <CopmareRaceImageFooter v-if="isShowComparesFooter"/>
        </div>
        <div v-else class="px-4 py-2">Pictures not found</div>
      </div>
    </div>
    <ImageViewer :paramImageId="selectedImg" @close="closeImageViewer" v-if="selectedImg"/>
  </div>
</template>

<script>
import { getFavoritesRaceImages, getRaceFavoritesImagesFilters } from '../../api/raceimages'
import RaceFilterSidebar from '../../components/raceImageComponents/RaceFilterSidebar'
import RaceFilterHeader from '../../components/raceImageComponents/RaceFilterHeader'
import CopmareRaceImageFooter from '../../components/raceImageComponents/CopmareRaceImageFooter'
import BaseScrollbar from '../../components/BaseScrollbar';
import { mapActions, mapGetters } from 'vuex';
import ShowAsideButton from '../../components/ShowAsideButton'
import RecycleRaceGallery from '../../components/raceImageComponents/RecycleRaceGallery'
import ImageViewer from '../image/ImagePage.vue'

export default {
  name: 'Favorites',
  components: {
    RaceFilterSidebar,
    BaseScrollbar,
    CopmareRaceImageFooter,
    RaceFilterHeader,
    ShowAsideButton,
    RecycleRaceGallery,
    ImageViewer
  },
  computed: {
    ...mapGetters({
      currentCompareImages: 'race/getComparesImagesByCurrentRaceId',
      currentBaselineCompareImage: 'race/getCurrentBaselineComparesImages',
      ordered: 'race/getOrdered',
    }),
    raceId() {
      return this.$route.params.raceId
    },
    isShowComparesFooter() {
      return !!this.currentCompareImages.length || this.currentBaselineCompareImage
    },
    queryFilters() {
      return this.$route.query
    }
  },
  data() {
    return {
      images: [],
      isLoadingRaceImages: false,
      totalCountImages: 0,
      filters: {header_filters: [], left_filters: []},
      selectedFilters: {},
      previousPage: 0,
      currentPage: 1,
      imagesLimit: 24,
      isSendPagination: true,
      filteredCountImages: 0,
      minPage: 0,
      maxPage: 0,
      cardHeight: 0,
      isShowFiltersAside: true,
      order: 'created_date',
      newImgList: [],
      selectedImg: null
    }
  },
  methods: {
    ...mapActions({
      setCurrentRace: 'race/setCurrentRace'
    }),
    updatePage() {
      getRaceFavoritesImagesFilters(this.raceId, {...this.selectedFilters})
        .then(res => {
          this.filters = res.data.filter
          return res
        })
        .catch(e => console.log(e))
      this.isLoadingRaceImages = true
      return getFavoritesRaceImages(this.raceId, {limit: this.imagesLimit, page: this.currentPage, ...this.selectedFilters})
        .then(res => {
          if (!res.data.filtered_count) {
            this.$router.push({ name: `favorites`, params: { raceId: this.raceId }})
            return res
          }
          this.newImgList = res.data.images.map(img => {return {...img, favorite: true}})
          if (this.currentPage > this.previousPage) {
            this.images.push(...this.newImgList)
          } else {
            this.images.unshift(...this.newImgList)
          }
          this.totalCountImages = res.data.total
          this.filteredCountImages = res.data.filtered_count
          this.isSendPagination = true
          if (this.images.length) {
            this.setCurrentRace({ name: this.images[0].race_event, id: this.images[0].race_id })
          }
          return res
        })
        .catch(e => console.log(e))
        .finally(() => this.isLoadingRaceImages = false)
    },
    changeFiltersHandler(filter, filterTitle, filterPosition) {
      let filterVar = this.filters[filterPosition][filterTitle].filter_var
      this.currentPage = 0
      if (Array.isArray(filter)) {
        this.selectedFilters[filterVar] = filter
      } else if (!this.selectedFilters[filterVar]) {
        this.selectedFilters[filterVar] = [filter]
      } else {
        const index = this.selectedFilters[filterVar].findIndex(item => item === filter)
        if (index === -1) {
          this.selectedFilters[filterVar].push(filter)
        } else {
          this.selectedFilters[filterVar].splice(index, 1)
        }
      }
      this.images = []
      // this.$refs.raceGallery.clean()
      this.currentPage = 1
      this.minPage = 0
      this.maxPage = 0
      this.$router.push({
        name: this.$route.name,
        params: { raceId: this.raceId },
        query: { ...this.selectedFilters, order: this.order }
      })
    },
    getFiltersFromQuery() {
      const { page, order, ...query } = {...this.$route.query}
      for (let filter in query) {
        query[filter] = Array.isArray(query[filter]) ? [...query[filter]] : [query[filter]]
      }
      this.order = order ? order : this.ordered
      this.currentPage = page ? +page : 1
      if (this.minPage === 0 && this.maxPage === 0) {
        this.minPage = this.currentPage
        this.maxPage = this.currentPage
      }
      this.selectedFilters = query
      let filters = this.filters
      this.filters = {header_filters: [], left_filters: []}
      this.$nextTick(() => this.filters = filters)
    },
    scrollyend() {
      if (this.images.length < this.filteredCountImages && this.isSendPagination) {
        this.isSendPagination = false
        this.previousPage = this.currentPage
        this.maxPage++
        this.updatePage(this.maxPage)
      }
    },
    scrollystart() {
      if (this.images.length < this.filteredCountImages && this.isSendPagination && this.currentPage > 1 && this.minPage > 1) {
        this.isSendPagination = false
        this.previousPage = this.currentPage
        this.minPage--
        this.updatePage(this.minPage)
      }
    },
    clearFilters() {
      if (Object.keys(this.selectedFilters).length) {
        this.images = []
        if (this.$refs.raceGallery?.clean) {
          this.$refs.raceGallery.clean() // TODO  looks like clean method is not exist
        }
        this.currentPage = 1
        this.selectedFilters = {}
        this.$router.push({ name: this.$route.name, params: { raceId: this.raceId }})
      }
    },
    scroll(scrollPosition) {
      if (this.maxPage > 0) {
        let onePage = 100 / (this.maxPage - this.minPage)
        let pageNumber = Math.floor(scrollPosition / onePage) + this.minPage
        if (pageNumber > 0 && pageNumber !== this.currentPage && (pageNumber > this.minPage || pageNumber < this.maxPage)) {
          this.$router.push({
            name: this.$route.name,
            params: {raceId: this.raceId },
            query: {...this.selectedFilters, page: pageNumber}
          })
        }
      }
    },
    changeIsShowFiltersAside() {
      this.isShowFiltersAside = !this.isShowFiltersAside
    },
    changeOrder(order) {
      this.$router.push({ name: this.$route.name, params: { raceId: this.raceId }, query: { ...this.selectedFilters, order: order }})
    },
    closeImageViewer() {
      this.selectedImg = null
    },
    selectImg(imgId) {
      this.selectedImg = imgId
    },
    async changeImage(direction) {
      let imageIndex = this.images.findIndex(({_id}) => _id === this.selectedImg)
      if(imageIndex === 0 || imageIndex === this.images.length - 1) {
        await this.updatePage(imageIndex === this.images.length - 1 ? this.minPage : this.maxPage, imageIndex === this.images.length - 1 ? 'end' : 'start')
        imageIndex = this.images.findIndex(({_id}) => _id === this.selectedImg)
      }
      this.selectedImg = direction === 'next' ? this.images[imageIndex + 1]._id : this.images[imageIndex - 1]._id
    }
  },
  watch: {
    queryFilters(value) {
      this.getFiltersFromQuery()
      if (this.currentPage < this.minPage || this.currentPage > this.maxPage || !value.page) {
        this.updatePage(this.currentPage)
      }
    },
    minPage() {
      if(this.maxPage - this.minPage > 1) {
        let scrollposition = 1 / (this.maxPage - this.minPage)
        this.$nextTick(() => {
          this.$refs.raceGallery.$refs.bodyScrollbar.wrap.scrollTop = this.$refs.raceGallery.$refs.bodyScrollbar.wrap.scrollHeight * scrollposition
          this.$refs.raceGallery.$refs.bodyScrollbar.update()
        })
      }
    },
    isShowFiltersAside() {
      if (this.images) {
        this.$nextTick(() => {
          this.$refs.raceGallery.updateCardHeight()
        })
      }
    },
    order() {
      this.images = []
      if (this.$refs.raceGallery) {
        this.$refs.raceGallery.clean()
      }
      this.currentPage = 1
      this.selectedFilters = {}
    }
  },
  mounted() {
    this.getFiltersFromQuery()
    this.updatePage(this.currentPage)
    .then(()=> {
      this.$refs.raceGallery.updateCardHeight()
      let scrollposition = this.currentPage > 1 ? 0.5 : 0
      if (scrollposition > 0 && scrollposition < 1) {
        this.$nextTick(() => {
          this.$refs.raceGallery.$refs.bodyScrollbar.wrap.scrollTop = this.$refs.raceGallery.$refs.bodyScrollbar.wrap.scrollHeight * scrollposition
          this.$refs.raceGallery.$refs.bodyScrollbar.update()
        })
      }
    })
  }
}
</script>

<style lang="scss" scoped>
  .race-page-header {
    display: flex;
    padding: 10px;
    align-items: center;
    .page-title.el-text--heading {
      margin: 0;
    }
  }

  .race-page-wrapper {
    display: flex;
    height: calc(100% - 65px);

    .race-page-main {
      flex-grow: 1;
    }
    .race-page-main {
      ::v-deep {
        .el-scrollable {
          &.is-compare-footer {
            height: calc(100% - 100px);
          }
        }
      }
    }
  }
  ::v-deep {
    .hide-btn.show-aside-button {
      left: 15px;
      bottom: 15px;
      &.is-open {
        left: 220px;
      }
    }
  }
  .race-page-wrapper-global, .race-page {
    height: 100%;
  }
</style>
